import React from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Home from './pages/Home';
import CakeDetails from './pages/CakeDetails';
import CategoryPage from './pages/CategoryPage';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import MyOrders from './pages/MyOrders';
import Login from './pages/Login';
import BottomNav from './components/BottomNav';
import SquircleDefs from './components/SquircleDefs';
import './App.css';

function AppContent() {
  const location = useLocation();
  const hideNavRoutes = ['/login', '/checkout', '/order-success', '/cart'];
  const shouldShowNav = !hideNavRoutes.includes(location.pathname) && 
                         !location.pathname.startsWith('/category/') && 
                         !location.pathname.startsWith('/cake/');

  return (
    <div className={`App ${shouldShowNav ? 'with-nav' : ''}`}>
      <SquircleDefs />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/cake/:id" element={<CakeDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/category/:categoryId" element={<CategoryPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/orders" element={<MyOrders />} />
      </Routes>
      {shouldShowNav && <BottomNav />}
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <AppContent />
      </Router>
    </CartProvider>
  );
}

export default App;
